module.exports = __webpack_public_path__ + "img/hand1.351cf54a.svg";